import { createApi } from '@reduxjs/toolkit/query/react'
import { API_ENDPOINTS } from 'Constants'
import { FileManagerModelResponse } from 'Pages/Customer360/types'

import { bobFmsRealUrlQuery } from 'Services/baseQuery'

export const bobFmsApiReal = createApi({
  reducerPath: 'abc',
  baseQuery: bobFmsRealUrlQuery,
  endpoints: (builder) => ({
    uploadFile: builder.mutation<

      FileManagerModelResponse,
      Record<string, any>
    >({
      query: (filters) => ({
        url: API_ENDPOINTS.BOB.FMS_FILE_UPLOAD,
        method: 'POST',
        body: filters,
        rawResponse: true,
        headers: { Lang: 'EN' },
      }),
    }),
  }),
})

export const { useUploadFileMutation } = bobFmsApiReal
